<template>
  <div id="contenedor-listado-desktop">
    <v-row no-gutters class="px-8 pt-3">

      <v-col cols="6">
        <span>Fondo</span>
      </v-col>
      <v-col cols="2" class="text-center">
        <span>Autorizado</span>
      </v-col>
      <v-col cols="2" class="text-center">
        <span>Modificado</span>
      </v-col>
      <v-col cols="1" class="text-center">
        <small>Cerrado</small>
      </v-col>
      <v-col cols="1"></v-col>
    </v-row>
    <v-expansion-panels accordion>
      <v-expansion-panel
        v-for="presupuesto in getPresupuestos"
        :key="presupuesto.id">
        <v-expansion-panel-header
          class="bkground py-0"
          hide-actions>
          <v-row align="center">
            <v-col cols="6" class="py-0">
              <small>{{ presupuesto.fuente.nombre }}</small>
            </v-col>
            <v-col cols="2" class="py-0 text-right">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <span
                    v-on="on"
                    :class="colorImporte(presupuesto)">
                    {{ getSumaImporteDetalles(presupuesto) | currency }}
                  </span>
                </template>
                <span>Capturado: {{ presupuesto.importe | currency }}</span>
              </v-tooltip>
            </v-col>
            <v-col cols="2" class="py-0 text-right">
              <span>{{ getImporteModificado(presupuesto) | currency }}</span>
            </v-col>
            <!-- <v-col cols="2" class="py-0">
              <fecha-humano :fecha="new Date(presupuesto.createdAt)" />
            </v-col> -->
            <v-col cols="1" class="py-0 text-center">
              <v-icon :class="getIconColor(presupuesto)">
                {{ getIcon(presupuesto) }}
              </v-icon>
            </v-col>
            <v-col cols="1" class="py-0">
              <v-row justify="end">
                <opciones :presupuesto="presupuesto"></opciones>
              </v-row>
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <listado-detalles :presupuestoId="presupuesto.id"/>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import mixPresupuestos from '@/components/administracion/presupuestos/mixPresupuestos';
import ListadoDetalles from './presupuestosDetalles/Listado.vue';
import Opciones from './Opciones.vue';
// import FechaHumano from '@/components/FechaHumano.vue';
// import CustomSelect from '@/components/inputs/Select.vue';

export default {
  name: 'ListadoPresupuestosDesktop',
  mixins: [mixPresupuestos],
  components: {
    Opciones,
    // FechaHumano,
    ListadoDetalles,
    // CustomSelect,
  },
  props: {
    ejercicio: Number,
  },
  data() {
    return {
      verDetalle: false,
      presupuestoId: null,
      headers: [
        // {
        //   text: 'Ejercicio', value: 'ejercicio', sortable: false,
        // },
        {
          text: 'Fuente Financiera', value: 'fuente.nombre', sortable: false,
        },
        {
          text: 'Importe Autorizado', value: 'importe', sortable: false, align: 'end',
        },
        {
          text: 'Importe Modificado', value: 'modificado', sortable: false, align: 'end',
        },
        { text: 'Detalles', value: 'detalles', sortable: false },
        { text: 'F. Registro', value: 'createdAt' },
        {
          text: 'Original',
          value: 'esPresupuestoOriginal',
          sortable: false,
          align: 'center',
        },
        {
          text: '', value: 'acciones', align: 'end', sortable: false,
        },
      ],
    };
  },
  methods: {
    getIconColor(presupuesto) {
      return presupuesto.esPresupuestoOriginal ? 'success--text' : 'error--text';
    },
    getIcon(presupuesto) {
      // return presupuesto.esPresupuestoOriginal ? 'check_circle' : 'unpublished';
      return presupuesto.esPresupuestoOriginal ? 'mdi-lock' : 'mdi-lock-open-variant';
    },
    colorImporte({ importe, detalles }) {
      const sumaDetalles = this.getSumaImporteDetalles({ detalles });
      const sumaModificados = this.getImporteModificado({ detalles });
      if (importe === sumaDetalles && importe === sumaModificados) return 'base1--text font-weight-medium';
      if (importe === sumaDetalles) return 'error--text font-weight-medium';
      return 'font-weight-medium';
    },
    getImporteModificado({ detalles }) {
      let total = 0;
      detalles.forEach(({ importe, modificaciones }) => {
        const sumaModificaciones = modificaciones.reduce((acc, elem) => acc + elem.importe, 0);
        const preTotal = importe + sumaModificaciones;
        total += preTotal;
      });
      return total;
    },
    getSumaImporteDetalles({ detalles }) {
      return detalles.reduce((acc, elem) => acc + elem.importe, 0);
    },
    preVerDetalles({ id }) {
      if (!id) return;
      this.presupuestoId = id;
      // this.detalles = detalles;
      this.verDetalle = true;
    },
  },
  computed: {
    getPresupuestos() {
      if (!this.presupuestos) return [];
      return this.presupuestos.filter((item) => Number(item.ejercicio) === Number(this.ejercicio));
    },
    // getTotalAutorizado() {
    //   return this.getPresupuestos.reduce((acc, elem) => acc + elem.importe, 0);
    // },
    // getTotalModificado() {
    //   let total = 0;
    //   this.getPresupuestos.forEach((presupuesto) => {
    //     total += this.getImporteModificado(presupuesto);
    //   });
    //   return total;
    // },
    // getColorTotalModificado() {
    //   return this.getTotalAutorizado === this.getTotalModificado ? 'success' : 'warning';
    // },
  },
};
</script>

<style lang="scss"></style>
